/**
 * Returns whether array contains at least one element matching the condition of the predicate
 * @param array
 * @param predicate
 */
export function arrayIncludes<T>(
  array: readonly T[],
  predicate: (item: T, index: number, array: readonly T[]) => boolean,
): boolean {
  return array.find(predicate) !== undefined
}